import apps from "../apps";

const {GENIES} = apps;

export function isHavePermissionThisApp(user) {
    try {
        if (user.profile.IsSuperAdmin) return true;
        const apps = user.profile.Apps.split(',');
        console.error("apps", apps)
        if (apps.indexOf(GENIES.id) > -1) {
            return true;
        }
    } catch(e) {
        return false;
    }
    return false
}

export function getTheAppsUrlToByRedirected(user) {
    try {
        const userApps = user.profile.Apps.split(',');
        try {
            Object.keys(apps).forEach((appName) => {
                if (userApps.indexOf(apps[appName].id) > -1) {
                    console.error(apps[appName].url)
                    throw apps[appName].url;
                }
            })
        } catch (url) {
            return url;
        }
    } catch (e) {
        return ""
    }
    
    return "";
}